import { render } from "./crossTransfer.vue?vue&type=template&id=2edab1ca&scoped=true"
import script from "./crossTransfer.vue?vue&type=script&lang=js"
export * from "./crossTransfer.vue?vue&type=script&lang=js"

import "./crossTransfer.vue?vue&type=style&index=0&id=2edab1ca&lang=less&scoped=true"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edab1ca"]])

export default __exports__